import React, {memo, useReducer, useState, useEffect} from 'react';
import Image from 'next/image';
import classNames from 'classnames';
import {useRouter} from 'next/router';

import {reducer} from '@reducers/product/list';
import CloseImg from '@imageWrapper/closeImg';
import {pageUrl} from '@utils/product';

import Category from './Filters/Category';
import Retailers from './Filters/Retailers';
import Shipping from './Filters/Shipping';
import Brands from './Filters/Brands';
import Price from './Filters/Price';
import AppliedFilter from './AppliedFilter';
import Options from './Filters/Options';

function MobileFilter(props) {
	const {styles, filters, url, params, dispatchList} = props;
	const router = useRouter();
	const [state, dispatch] = useReducer(reducer, {
		status: false,
		filterType: null,
		filter: null,
		showCount: false,
	});

	let filterType = state.filterType;
	let label = filterType;
	let optionId = null;

	if (state.filterType && state.filterType.match('Option')) {
		let op = state.filterType.split('||');
		filterType = 'Option';
		label = op[1];
		optionId = op[2];
	}

	const close = () => {
		let data = {};
		if (state.filterType) {
			data.filterType = null;
		} else {
			data.status = false;
		}

		data.filter = null;

		dispatch({
			type: 'SET_DATA',
			data,
		});
	};

	const setFilterType = filterType => {
		dispatch({
			type: 'SET_DATA',
			data: {
				filterType,
				showCount: false,
			},
		});
	};

	const setStatus = status => {
		dispatch({
			type: 'SET_DATA',
			data: {
				status,
			},
		});
	};

	const setFilter = filter => {
		dispatch({
			type: 'SET_DATA',
			data: {
				filter,
			},
		});
	};

	const applyNow = () => {
		dispatchList({
			type: 'SET_DATA',
			data: {
				loading: true,
			},
		});
		if (state.filterType === 'Categories') {
			const slug =
				state.filter.cl3 || state.filter.cl2 || state.filter.cl1 || '';
			const query = state.filter.cl4
				? {category: Object.keys(state.filter.cl4).join('|')}
				: {};
			if (props.filters.sortBy) query.sortBy = props.filters.sortBy;

			router.push({
				pathname: pageUrl(props, slug),
				query,
			});
		} else if (state.filterType === 'Price') {
			let query = {...props.params, ...state.filter};
			delete query.page;
			delete query.error;
			router.push({
				pathname: url,
				query,
			});
		} else {
			const params = {},
				opIds = {};
			for (let i = 0; i < state.filter.length; i++) {
				const filter = state.filter[i];
				if (filter.type === 'options') {
					if (opIds[filter.masId]) {
						opIds[filter.masId].push(filter._id);
					} else {
						opIds[filter.masId] = [filter._id];
					}
				} else {
					if (params[filter.type]) {
						params[filter.type] += `|${filter._id}`;
					} else {
						params[filter.type] = filter._id;
					}
				}
			}

			if (Object.keys(opIds).length) {
				params.options = Object.keys(opIds)
					.map(i => opIds[i].join('|'))
					.join('||');
			}
			let type = '';
			if (state.filterType === 'Retailer') {
				type = 'retailer';
				props.retailers.updateFilter(state.filter);
			} else if (state.filterType === 'Brand') {
				type = 'brand';
				props.brands.updateFilter(state.filter);
			} else if (filterType === 'Option') {
				type = 'options';
				props.options.updateFilter(state.filter);
			}

			let query = {...props.params};
			delete query.page;
			if (Object.keys(params).length) {
				query = {...query, ...params};
			} else {
				delete query[type];
			}

			router.push({
				pathname: url,
				query,
			});
		}

		dispatch({
			type: 'SET_DATA',
			data: {
				filterType: null,
				filter: null,
				showCount: true,
			},
		});
	};

	const showList = () => {
		dispatch({
			type: 'SET_DATA',
			data: {
				status: false,
				filterType: null,
				filter: null,
				showCount: false,
			},
		});
	};
	return (
		<>
			<div className={styles.mobileFilter}>
				<ul
					className={`d-flex align-items-center justify-content-between ${styles.positionUl}`}
				>
					<li>
						<h6>Product Details</h6>
					</li>
					<li className={styles.filterIcon}>
						<i
							className='fa fa-filter'
							aria-hidden='true'
							onClick={() => setStatus(true)}
						></i>
					</li>
					<SortBy
						styles={styles}
						filters={filters}
						pageUrl={url}
						params={params}
					/>
				</ul>
			</div>

			<div
				className={styles.deskFilter}
				style={{display: state.status ? 'block' : 'none'}}
			>
				<div className={styles.filterMobile}>
					<div className={styles.mobStoreFilter}>
						<h2>
							<span>{label || 'Filter'}</span>
						</h2>
						<a onClick={() => close()} className={styles.closeFilter}>
							{
								// eslint-disable-next-line @next/next/no-img-element
								<img src='/assets/images/filter-close.png' alt='filter-close' />
							}
						</a>
					</div>
				</div>
				<div className={`${styles.listingFilter} ${styles.mobFilter}`}>
					{!filterType && (
						<div className={styles.filterBadgeMobile}>
							<AppliedFilter
								filters={filters}
								styles={styles}
								removeFilter={props.removeFilter}
								clearAllFilter={props.clearAllFilter}
							/>
						</div>
					)}
					<div className={classNames(styles.levelMenu, styles.levelMenuOne)}>
						{filterType ? (
							<>
								{filterType === 'Categories' && (
									<Category {...props} isMobile={true} setFilter={setFilter} />
								)}
								{filterType === 'Price' && (
									<Price {...props} isMobile={true} setFilter={setFilter} />
								)}
								{filterType === 'Retailer' && (
									<Retailers {...props} isMobile={true} setFilter={setFilter} />
								)}

								{filterType === 'Shipping' && (
									<Shipping {...props} isMobile={true} setFilter={setFilter} />
								)}
								{filterType === 'Brand' && (
									<Brands {...props} isMobile={true} setFilter={setFilter} />
								)}
								{filterType === 'Option' && (
									<Options
										{...props}
										optionId={optionId}
										isMobile={true}
										setFilter={setFilter}
									/>
								)}
							</>
						) : (
							<ul>
								<li
									className={styles.filterCatgHd}
									onClick={() => setFilterType('Categories')}
								>
									Categories
								</li>
								<li
									className={styles.filterCatgHd}
									onClick={() => setFilterType('Price')}
								>
									Price
								</li>
								{!props.store && !props.isAuction && (
									<>
										<li
											className={styles.filterCatgHd}
											onClick={() => setFilterType('Shipping')}
										>
											Item can ship to
										</li>
										<li
											className={styles.filterCatgHd}
											onClick={() => setFilterType('Retailer')}
										>
											Retailer
										</li>
									</>
								)}
								{!props.brand && !props.isAuction && (
									<li
										className={styles.filterCatgHd}
										onClick={() => setFilterType('Brand')}
									>
										Brand
									</li>
								)}
								<Options
									{...props}
									isMobile={true}
									showLabel={true}
									setFilterType={(label, id) =>
										setFilterType(`Option||${label}||${id}`)
									}
								/>
							</ul>
						)}
					</div>
				</div>
				{state.filter && !state.filter?.error && (
					<div className={styles.mobApplyBtn}>
						<button onClick={applyNow}>
							Apply Now <i className='fa fa-angle-right'></i>
						</button>
					</div>
				)}
				{state.showCount && (
					<div className={styles.mobApplyBtn}>
						<button onClick={showList}>
							{props.loading
								? 'Loading...'
								: `Show ${props.total} ${props.total > 1 ? 'Pieces' : 'Piece'}`}
						</button>
					</div>
				)}
			</div>
		</>
	);
}

const wrapperRef = React.createRef();
const sortItems = {
	1: 'Newest First',
	2: 'Price low to high',
	3: 'Price high to low',
	4: 'Alphabetical A-Z',
	5: 'Alphabetical Z-A',
};

function SortBy(props) {
	const router = useRouter();
	const [show, setShow] = useState(false);
	const {styles, filters} = props;

	useEffect(() => {
		const outSideModalClickEvent = () => {
			if (wrapperRef && !wrapperRef.current?.contains(event.target)) {
				setShow(false);
				// removeListener();
			}
		};
		const removeListener = () => {
			document.removeEventListener('mousedown', outSideModalClickEvent);
		};
		document.addEventListener('mousedown', outSideModalClickEvent);

		return () => removeListener;
	}, []);

	const sortby = sort => {
		setShow(false);
		const query = {...props.params, sortBy: sort};
		if (filters.sortBy && sort === filters.sortBy) return;
		if (sort === 1) delete query.sortBy;
		delete query.page;
		router.push({pathname: props.pageUrl, query});
	};
	const hideShow = () => {
		setShow(false);
	};

	useEffect(() => {
		if (show) {
			document.body.style.overflowY = 'hidden';
		} else {
			document.body.style.removeProperty('overflow-y');
		}
	}, [show]);
	return (
		<>
			<li>
				<div className={styles.sortImage} onClick={() => setShow(true)}>
					<Image alt='Sort' layout='fill' src={'/assets/images/sort.png'} />
				</div>
			</li>
			{show && (
				<>
					<div className={styles.mobSortOverlay}></div>
					<div className={styles.mobSortContents} ref={wrapperRef}>
						<div className={styles.closeButtonSort} onClick={hideShow}>
							<CloseImg click={hideShow} />
						</div>{' '}
						<ul>
							{Object.keys(sortItems).map(k => (
								<li key={k}>
									<a onClick={() => sortby(k)}>{sortItems[k]}</a>
								</li>
							))}
						</ul>
					</div>
				</>
			)}
		</>
	);
}

export default memo(MobileFilter);
